import './CommunityLanguage.css'
import { useTranslation } from 'react-i18next'
import { useState, useEffect } from 'react'
import { memo } from 'react'

import useLocalStorage from '../../translator/hooks/useLocalStorage'
import i18n from '../../translator/i18next'
import { Popup } from '../Popup/Popup'

const CommunityLanguageComponent = (props) => {
	const { t } = useTranslation()
	const currentLanguage = localStorage.getItem('language')
	const browserLanguage = navigator.language || navigator.userLanguage
	const [language, setLanguage] = useLocalStorage('language', 'ru')
	const [ruIsActive, setRuIsActive] = useState(false)
	const [enIsActive, setEnIsActive] = useState(false)

	useEffect(() => {
		if (!currentLanguage) {
			if (browserLanguage === 'ru' || browserLanguage === 'ru-RU') {
				setRuIsActive(true)
				setEnIsActive(false)
				setLanguage('ru')
			} else if (browserLanguage !== 'ru' || browserLanguage !== 'ru-RU') {
				setEnIsActive(true)
				setRuIsActive(false)
				setLanguage('en')
			}
		} else if (JSON.parse(currentLanguage) === 'ru') {
			setRuIsActive(true)
			setEnIsActive(false)
			setLanguage('ru')
		} else {
			setEnIsActive(true)
			setRuIsActive(false)
			setLanguage('en')
		}
	}, [language, browserLanguage])

	const changeOnEnglish = () => {
		setRuIsActive(false)
		i18n.changeLanguage('en')
		setLanguage('en')
	}

	const changeOnRussian = () => {
		setEnIsActive(false)
		i18n.changeLanguage('ru')
		setLanguage('ru')
	}

	return (
		<>
			<Popup onClose={props?.onClose} title={t('Community language')} close={true}>
				<div className="translator-popup">
					<input
						checked={ruIsActive}
						id="radio-ru"
						name="language"
						type="radio"
						value={1}
						onChange={changeOnRussian}
						onClick={changeOnEnglish}
						className="translator-popup__inputs-radio"
					/>

					<label htmlFor="radio-ru">
						{ t('Russian') }
					</label>
				</div>

				<div className="translator-popup">
					<input
						checked={enIsActive}
						id="radio-en"
						name="language"
						type="radio"
						value={2}
						onChange={changeOnEnglish}
						onClick={changeOnRussian}
						className="translator-popup__inputs-radio"
					/>

					<label htmlFor="radio-en">
						{ t('English') }
					</label>
				</div>
			</Popup>
		</>
	)
}

export const CommunityLanguage = memo(CommunityLanguageComponent)
